module.exports = __webpack_public_path__ + "img/10.f1e3bada.jpg";